import { render, staticRenderFns } from "./LicensesSearch.vue?vue&type=template&id=676fed22"
import script from "./LicensesSearch.vue?vue&type=script&lang=js"
export * from "./LicensesSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports